import { ClassNames } from '@emotion/react';
import { useLingui } from '@lingui/react/macro';
import React from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import UDInput, { UDInputProps } from 'ud-form/components/input/component';
import { useCalendarLayer } from './calendar-motion';
import { calendarStyles, popperStyles, wrapperStyles } from './calendar-styles';
import { timeHelpers } from './helpers';

export type UDTimeInputProps = Omit<
  ReactDatePickerProps,
  'dateFormat' | 'customInput' | 'placeholderText' | 'showTimeSelect' | 'showTimeSelectOnly' | 'timeCaption'
> &
  Pick<UDInputProps, 'hasError' | 'valid'>;

const TIME_FORMAT = 'HH:mm';

const UDTimeInput = (props: UDTimeInputProps) => {
  const { value, hasError, valid, timeIntervals, wrapperClassName, calendarClassName, popperClassName, ...datePickerProps } = props;
  const { t } = useLingui();
  const CalendarLayer = useCalendarLayer();
  const parsedValue = value ? timeHelpers.parse(value) : null;

  return (
    <ClassNames>
      {({ css, cx, theme }) => (
        <DatePicker
          selected={parsedValue}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals}
          timeCaption={t`Время`}
          dateFormat={TIME_FORMAT}
          // Подпись пунктов списка — та же, что в поле; без неё формат локали (`p`) даёт «10:15 AM» в английском.
          timeFormat={TIME_FORMAT}
          placeholderText={t({ message: 'чч:мм', comment: 'Маска поля времени: часы и минуты' })}
          customInput={<UDInput hasError={hasError} valid={valid} />}
          showPopperArrow={false}
          popperContainer={CalendarLayer}
          {...datePickerProps}
          wrapperClassName={cx(css(wrapperStyles()), wrapperClassName)}
          calendarClassName={cx(css(calendarStyles(theme)), calendarClassName)}
          popperClassName={cx(css(popperStyles(theme)), popperClassName)}
          onChange={(date, e) => datePickerProps.onChange(timeHelpers.extract(date), e)}
        />
      )}
    </ClassNames>
  );
};

export default UDTimeInput;
